import React, { useEffect } from 'react';
import { inject } from 'mobx-react';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider } from '@material-ui/styles';
import { Route, Switch, Redirect } from 'react-router-dom';

import theme from './static/theme';
import routes from './lib/router';
import { NoticeModal } from './components/notice';
import { ChatWidget } from './components/chat';
import './static/css/style.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-datepicker/dist/react-datepicker.css";

const MyRouter = ({ layout: Layout, component: Component, strict = false, ...rest }) => {
  return (
    <Route
      strict
      {...rest}
      render={(props) => (
        <Layout>
          <Component {...props} />
        </Layout>
      )}
    />
  )
}

function App({ loginStore }) {
  const { meCall } = loginStore;
  useEffect(() => {
    // 카카오 JS 키·아임포트 가맹점 코드는 빌드 환경변수로 바꿀 수 있다 (REACT_APP_KAKAO_JS_KEY / REACT_APP_IAMPORT_CODE)
    if (window.Kakao && !window.Kakao.isInitialized()) {
      window.Kakao.init(process.env.REACT_APP_KAKAO_JS_KEY || '15a47e163ff40cf9ac569dc7a94c7b79');
    }
    if (window.IMP) window.IMP.init(process.env.REACT_APP_IAMPORT_CODE || 'imp13090698');

    meCall();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <NoticeModal />
      <ChatWidget />

      <Switch>
        {
          routes.map((r, idx) => {
            return (
              <MyRouter
                exact={r.exact}
                path={r.path}
                layout={r.layout}
                component={r.component}
                strict={r.strict}
                key={idx}
              />
            )
          })
        }
        <Redirect path="/" to="/quickservice" />
      </Switch>
    </ThemeProvider>
  );
}

export default inject('loginStore')(App);
